export type Locale = 'en' | 'ja' | 'ja-Hira'

const messages = {
  en: {
    documentTitle: 'WireScope · Live screen',
    subtitle: 'Live screen · read-only',
    languageSwitch: '日本語',
    languageSwitchLabel: 'Show WireScope in Japanese',
    statusStarting: 'Starting WireScope…',
    statusDirectNavigation: 'Open WireScope from a connected source, such as Scratch or Python.',
    statusWaitingForSource: 'Waiting for Scratch to attach a secure channel…',
    statusChannelAttached: 'Secure channel attached. Redeeming one-time grant…',
    statusGrantRedeemed: 'Observation grant redeemed. Waiting for frames…',
    statusStationReady: 'Station ready. Enter the attach code shown in the Python terminal.',
    statusStationTargetNotReady: 'Waiting for the Python observation target. Enter its code when shown.',
    statusStationAttaching: 'Checking the one-time attach code…',
    statusStationAttached: 'Station attached. Waiting for observation frames…',
    statusObserving: 'Observing {count} {streams}',
    streamCountOne: 'stream',
    streamCountMany: 'streams',
    emptyTitle: 'Waiting for an observation target',
    emptyBody: 'Connect Scratch to Minecraft, then open WireScope from WireScope mini.',
    stationEmptyTitle: 'Attach to the Python observation target',
    stationEmptyBody: 'Enter the short-lived code shown in the same Python terminal. The code is not stored.',
    stationAttachTitle: 'Python station attach',
    stationAttachHelp: 'Use the one-time code printed by the Python process.',
    stationAttachPlaceholder: 'ABCD-EFGH',
    stationAttachInputLabel: 'WireScope station attach code',
    stationAttachSubmit: 'Attach',
    sourceScratch: 'Scratch source',
    sourcePython: 'Python source',
    readOnly: 'READ ONLY',
    streamTabs: 'Streams',
    streamMain: 'Main stream',
    streamSubstream: 'substream',
    streamConnected: 'connected',
    streamError: 'error',
    streamEnded: 'ended',
    handshake: 'Handshake',
    fieldProtocol: 'Protocol',
    fieldMinecraft: 'Minecraft',
    fieldSupported: 'Supported',
    fieldDimension: 'Initial dimension',
    fieldOrigin: 'Initial origin',
    fieldWorldConstants: 'World constants',
    fieldSeaLevel: 'Sea level',
    fieldCatalogHash: 'Catalog hash',
    fieldPermissions: 'Permissions',
    valueUnknown: 'unknown',
    valueNone: 'none',
    wireFrames: 'Wire frames',
    noFrames: 'No observable frames yet.',
    noFramesMatchFilter: 'No frames match the current filter.',
    columnTime: 'Time',
    columnDirection: 'Direction',
    columnMethod: 'Method',
    columnPayload: 'Payload',
    directionSend: 'send',
    directionSentUnconfirmed: 'Sent · unconfirmed',
    directionReceive: 'receive',
    historyWindowTruncated: '{count} older frames were omitted. Showing the most recent history.',
    framesPause: 'Pause display',
    framesResume: 'Resume display',
    framesPausedNewArrivals: 'Display paused · {count} new',
    endTarget: 'The observation target ended.',
    endSource: 'The observation source closed.',
    endBackpressure: 'Observation stopped because data arrived faster than WireScope could deliver it.',
    endCapacityExhausted: 'Observation stopped because one frame exceeded the WireScope capacity.',
    endTransportLost: 'The WireScope transport connection was lost.',
    errorGrantExpired: 'The observation grant expired before redemption.',
    errorTargetChanged: 'The source changed observation targets within one session.',
    errorInvalidEnd: 'The source sent an invalid observer end reason.',
    errorInvalidHistoryWindow: 'WireScope received invalid observation history metadata.',
    errorInvalidSession: 'WireScope received an invalid observer session message.',
    errorInvalidSnapshot: 'WireScope received invalid observation data.',
    attachErrorTargetNotReady: 'The Python observation target is not ready yet. Try again when its code appears.',
    attachErrorMalformedCode: 'Enter the eight-symbol attach code shown in the Python terminal.',
    attachErrorInvalidCode: 'That attach code does not match. Check the Python terminal and try again.',
    attachErrorAttemptsExhausted: 'Too many incorrect attempts. Wait for a new code in the Python terminal.',
    attachErrorCodeExpired: 'That attach code expired. Wait for a new code in the Python terminal.',
    attachErrorAlreadyRedeemed: 'That attach code was already used. This initial profile allows one browser only.',
    attachErrorInvalidRequest: 'The station rejected the attach request.',
    filterHeading: 'Filter',
    filterExpand: 'Show filter',
    filterCollapse: 'Hide filter',
    filterSummary: 'Filter: showing {visible} of {total}',
    filterMethodGroupHeading: 'Method groups',
    filterEventClassHeading: 'Event classes',
    filterMethodGroupConnection: 'connection',
    filterMethodGroupAuth: 'auth',
    filterMethodGroupBuild: 'build',
    filterMethodGroupCatalog: 'catalog',
    filterMethodGroupChat: 'chat',
    filterMethodGroupEvents: 'events',
    filterMethodGroupPlayer: 'player',
    filterMethodGroupWorld: 'world',
    filterMethodGroupOther: 'other',
    filterEventClassPickaxePoke: 'pickaxe poke',
    filterEventClassChatPosted: 'chat posted',
    filterEventClassProjectileHit: 'projectile hit',
    filterEventClassEmpty: 'empty',
    filterEventClassOther: 'other',
    filterOrSearchLabel: 'or',
    filterAndSearchLabel: 'and',
    filterSearchPlaceholder: 'keyword, keyword',
  },
  ja: {
    documentTitle: 'WireScope・ライブ画面',
    subtitle: 'ライブ画面・読み取り専用',
    languageSwitch: 'にほんご',
    languageSwitchLabel: 'WireScope をひらがなでひょうじ',
    statusStarting: 'WireScope を起動しています…',
    statusDirectNavigation: 'ScratchやPythonなど、接続中の観測元からWireScopeを開いてください。',
    statusWaitingForSource: 'Scratch からの安全なチャンネル接続を待っています…',
    statusChannelAttached: '安全なチャンネルに接続しました。一回限りの観測許可を確認しています…',
    statusGrantRedeemed: '観測許可を確認しました。フレームを待っています…',
    statusStationReady: 'stationの準備ができました。Python端末に表示された接続codeを入力してください。',
    statusStationTargetNotReady: 'Pythonの観測対象を待っています。codeが表示されたら入力してください。',
    statusStationAttaching: '一回限りの接続codeを確認しています…',
    statusStationAttached: 'stationへ接続しました。観測フレームを待っています…',
    statusObserving: '{count} 本のストリームを観測中',
    streamCountOne: 'ストリーム',
    streamCountMany: 'ストリーム',
    emptyTitle: '観測対象を待っています',
    emptyBody: 'Scratch を Minecraft に接続し、WireScope mini から WireScope を開いてください。',
    stationEmptyTitle: 'Pythonの観測対象へ接続',
    stationEmptyBody: '同じPython端末に表示された短命codeを入力してください。codeは保存されません。',
    stationAttachTitle: 'Python station接続',
    stationAttachHelp: 'Python processが表示した一回限りのcodeを使います。',
    stationAttachPlaceholder: 'ABCD-EFGH',
    stationAttachInputLabel: 'WireScope station接続code',
    stationAttachSubmit: '接続',
    sourceScratch: 'Scratch 接続元',
    sourcePython: 'Python 接続元',
    readOnly: '読み取り専用',
    streamTabs: 'ストリーム',
    streamMain: 'メインストリーム',
    streamSubstream: 'サブストリーム',
    streamConnected: '接続中',
    streamError: 'エラー',
    streamEnded: '終了',
    handshake: 'ハンドシェイク',
    fieldProtocol: 'プロトコル',
    fieldMinecraft: 'Minecraft',
    fieldSupported: '対応バージョン',
    fieldDimension: '初期次元',
    fieldOrigin: '初期原点',
    fieldWorldConstants: '世界定数',
    fieldSeaLevel: '海面の高さ',
    fieldCatalogHash: 'カタログハッシュ',
    fieldPermissions: '権限',
    valueUnknown: '不明',
    valueNone: 'なし',
    wireFrames: '通信フレーム',
    noFrames: 'まだ観測できるフレームはありません。',
    noFramesMatchFilter: '現在のフィルターに一致するフレームはありません。',
    columnTime: '時刻',
    columnDirection: '方向',
    columnMethod: 'メソッド',
    columnPayload: 'ペイロード',
    directionSend: '送信',
    directionSentUnconfirmed: '送信済み・結果未確認',
    directionReceive: '受信',
    historyWindowTruncated: '古いフレームを {count} 件省略し、直近の履歴を表示しています。',
    framesPause: '表示を一時停止',
    framesResume: '表示を再開',
    framesPausedNewArrivals: '表示停止中・新着 {count} 件',
    endTarget: '観測対象が終了しました。',
    endSource: '観測元が終了しました。',
    endBackpressure: 'データ流量が観測可限界を超えたため、観測を終了しました。',
    endCapacityExhausted: '1件のフレームがWireScopeの容量を超えたため、観測を終了しました。',
    endTransportLost: 'WireScopeの通信が切断されました。',
    errorGrantExpired: '観測許可を確認する前に有効期限が切れました。',
    errorTargetChanged: '同じセッション中に観測対象が変更されました。',
    errorInvalidEnd: '観測終了メッセージが不正です。',
    errorInvalidHistoryWindow: '観測履歴の情報が不正です。',
    errorInvalidSession: '観測セッションのメッセージが不正です。',
    errorInvalidSnapshot: '無効な観測データを受信しました。',
    attachErrorTargetNotReady: 'Pythonの観測対象はまだ準備中です。codeが表示されてから再試行してください。',
    attachErrorMalformedCode: 'Python端末に表示された8文字の接続codeを入力してください。',
    attachErrorInvalidCode: '接続codeが一致しません。Python端末を確認して再試行してください。',
    attachErrorAttemptsExhausted: '誤入力回数が上限に達しました。Python端末に新しいcodeが出るまで待ってください。',
    attachErrorCodeExpired: '接続codeの有効期限が切れました。Python端末に新しいcodeが出るまで待ってください。',
    attachErrorAlreadyRedeemed: 'その接続codeは使用済みです。初期profileで接続できるbrowserは1つだけです。',
    attachErrorInvalidRequest: 'stationが接続requestを拒否しました。',
    filterHeading: 'フィルター',
    filterExpand: 'フィルターを表示',
    filterCollapse: 'フィルターを隠す',
    filterSummary: 'フィルター: {total}件中{visible}件を表示',
    filterMethodGroupHeading: 'methodグループ',
    filterEventClassHeading: 'イベント種別',
    filterMethodGroupConnection: '接続',
    filterMethodGroupAuth: '認証',
    filterMethodGroupBuild: '建築',
    filterMethodGroupCatalog: 'カタログ',
    filterMethodGroupChat: 'チャット',
    filterMethodGroupEvents: 'イベント',
    filterMethodGroupPlayer: 'プレイヤー',
    filterMethodGroupWorld: 'ワールド',
    filterMethodGroupOther: 'その他',
    filterEventClassPickaxePoke: 'ツルハシでつつく',
    filterEventClassChatPosted: 'チャット投稿',
    filterEventClassProjectileHit: '発射物ヒット',
    filterEventClassEmpty: '空振り',
    filterEventClassOther: 'その他',
    filterOrSearchLabel: 'または（or）',
    filterAndSearchLabel: 'かつ（and）',
    filterSearchPlaceholder: 'キーワード, キーワード',
  },
  'ja-Hira': {
    documentTitle: 'WireScope・ライブがめん',
    subtitle: 'ライブがめん・よみとりせんよう',
    languageSwitch: 'English',
    languageSwitchLabel: 'WireScope をえいごでひょうじ',
    statusStarting: 'WireScope をきどうしています…',
    statusDirectNavigation: 'Scratch や Python など、せつぞくちゅうのかんそくもとから WireScope をひらいてください。',
    statusWaitingForSource: 'Scratch からのあんぜんなチャンネルせつぞくをまっています…',
    statusChannelAttached:
      'あんぜんなチャンネルにせつぞくしました。いちどだけつかえるかんそくきょかをかくにんしています…',
    statusGrantRedeemed: 'かんそくきょかをかくにんしました。フレームをまっています…',
    statusStationReady: 'station のじゅんびができました。Python たんまつのせつぞく code をいれてください。',
    statusStationTargetNotReady: 'Python のかんそくたいしょうをまっています。code がでたらいれてください。',
    statusStationAttaching: 'いちどだけつかえるせつぞく code をかくにんしています…',
    statusStationAttached: 'station へせつぞくしました。かんそくフレームをまっています…',
    statusObserving: '{count} ほんのストリームをかんそくちゅう',
    streamCountOne: 'ストリーム',
    streamCountMany: 'ストリーム',
    emptyTitle: 'かんそくするものをまっています',
    emptyBody: 'Scratch を Minecraft にせつぞくし、WireScope mini から WireScope をひらいてください。',
    stationEmptyTitle: 'Python のかんそくたいしょうへせつぞく',
    stationEmptyBody: 'おなじ Python たんまつにでたみじかい code をいれてください。code はほぞんされません。',
    stationAttachTitle: 'Python station せつぞく',
    stationAttachHelp: 'Python process がだした、いちどだけつかえる code をつかいます。',
    stationAttachPlaceholder: 'ABCD-EFGH',
    stationAttachInputLabel: 'WireScope station せつぞく code',
    stationAttachSubmit: 'せつぞく',
    sourceScratch: 'Scratch せつぞくもと',
    sourcePython: 'Python せつぞくもと',
    readOnly: 'よみとりせんよう',
    streamTabs: 'ストリーム',
    streamMain: 'メインストリーム',
    streamSubstream: 'サブストリーム',
    streamConnected: 'せつぞくちゅう',
    streamError: 'エラー',
    streamEnded: 'しゅうりょう',
    handshake: 'ハンドシェイク',
    fieldProtocol: 'プロトコル',
    fieldMinecraft: 'Minecraft',
    fieldSupported: 'たいおうバージョン',
    fieldDimension: 'はじめのじげん',
    fieldOrigin: 'はじめのげんてん',
    fieldWorldConstants: 'せかいのていすう',
    fieldSeaLevel: 'うみのたかさ',
    fieldCatalogHash: 'カタログハッシュ',
    fieldPermissions: 'けんげん',
    valueUnknown: 'ふめい',
    valueNone: 'なし',
    wireFrames: 'つうしんフレーム',
    noFrames: 'まだかんそくできるフレームはありません。',
    noFramesMatchFilter: 'いまのフィルターにあうフレームはありません。',
    columnTime: 'じこく',
    columnDirection: 'むき',
    columnMethod: 'メソッド',
    columnPayload: 'ペイロード',
    directionSend: 'そうしん',
    directionSentUnconfirmed: 'そうしんずみ・けっかみかくにん',
    directionReceive: 'じゅしん',
    historyWindowTruncated: 'ふるいフレームを {count} けんしょうりゃくし、さいきんのりれきをひょうじしています。',
    framesPause: 'ひょうじをいちじていし',
    framesResume: 'ひょうじをさいかい',
    framesPausedNewArrivals: 'ひょうじをとめています・あたらしいフレームが {count} けん',
    endTarget: 'かんそくするものがしゅうりょうしました。',
    endSource: 'かんそくもとがしゅうりょうしました。',
    endBackpressure: 'データのながれがはやすぎるため、かんそくをしゅうりょうしました。',
    endCapacityExhausted: 'ひとつのフレームがおおきすぎるため、かんそくをしゅうりょうしました。',
    endTransportLost: 'WireScope のつうしんがきれました。',
    errorGrantExpired: 'かんそくきょかをかくにんするまえにゆうこうきげんがきれました。',
    errorTargetChanged: 'おなじセッションのなかでかんそくするものがかわりました。',
    errorInvalidEnd: 'かんそくしゅうりょうメッセージがただしくありません。',
    errorInvalidHistoryWindow: 'かんそくりれきのじょうほうがただしくありません。',
    errorInvalidSession: 'かんそくセッションのメッセージがただしくありません。',
    errorInvalidSnapshot: 'ただしくないかんそくデータをじゅしんしました。',
    attachErrorTargetNotReady: 'Python のかんそくたいしょうはじゅんびちゅうです。code がでてからためしてください。',
    attachErrorMalformedCode: 'Python たんまつにでた8もじのせつぞく code をいれてください。',
    attachErrorInvalidCode: 'せつぞく code があいません。Python たんまつをみて、もういちどためしてください。',
    attachErrorAttemptsExhausted:
      'まちがいがじょうげんにたっしました。Python たんまつにあたらしい code がでるまでまってください。',
    attachErrorCodeExpired:
      'せつぞく code のじかんがきれました。Python たんまつにあたらしい code がでるまでまってください。',
    attachErrorAlreadyRedeemed: 'そのせつぞく code はつかわれました。さいしょの profile では browser は1つだけです。',
    attachErrorInvalidRequest: 'station がせつぞく request をうけつけませんでした。',
    filterHeading: 'フィルター',
    filterExpand: 'フィルターをひょうじ',
    filterCollapse: 'フィルターをかくす',
    filterSummary: 'フィルター: {total}けんちゅう{visible}けんをひょうじ',
    filterMethodGroupHeading: 'method グループ',
    filterEventClassHeading: 'イベントしゅべつ',
    filterMethodGroupConnection: 'せつぞく',
    filterMethodGroupAuth: 'にんしょう',
    filterMethodGroupBuild: 'けんちく',
    filterMethodGroupCatalog: 'カタログ',
    filterMethodGroupChat: 'チャット',
    filterMethodGroupEvents: 'イベント',
    filterMethodGroupPlayer: 'プレイヤー',
    filterMethodGroupWorld: 'ワールド',
    filterMethodGroupOther: 'そのた',
    filterEventClassPickaxePoke: 'つるはしでつつく',
    filterEventClassChatPosted: 'チャットとうこう',
    filterEventClassProjectileHit: 'はっしゃぶつヒット',
    filterEventClassEmpty: 'からぶり',
    filterEventClassOther: 'そのた',
    filterOrSearchLabel: 'または（or）',
    filterAndSearchLabel: 'かつ（and）',
    filterSearchPlaceholder: 'キーワード, キーワード',
  },
} as const

export type MessageKey = keyof (typeof messages)['en']
export const messageKeys = Object.keys(messages.en) as MessageKey[]

export const resolveLocale = (languages: readonly string[]): Locale => {
  for (const language of languages) {
    const normalized = language.toLowerCase()
    if (normalized === 'ja-hira') return 'ja-Hira'
    const base = normalized.split('-')[0]
    if (base === 'ja') return 'ja'
    if (base === 'en') return 'en'
  }
  return 'en'
}

export const translate = (
  locale: Locale,
  key: MessageKey,
  values: Readonly<Record<string, string | number>> = {},
): string =>
  messages[locale][key].replace(/\{([^}]+)\}/g, (placeholder, name: string) =>
    Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : placeholder,
  )
